module.exports = __webpack_public_path__ + "img/triple_pad.e4537abe.jpg";